import { render, staticRenderFns } from "./Visitante.vue?vue&type=template&id=0c858a81&"
import script from "./Visitante.vue?vue&type=script&lang=js&"
export * from "./Visitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports